import styled, { css } from 'styled-components';
import * as Popover from '@radix-ui/react-popover';
import HBBox from '../HBBox/HBBox';
import { withStyles } from '../../styles/layout/withStyles';
import { vars } from '../../theme';
import { Z_INDEX, fontSizes } from '../../styles';

export const SelectRoot = styled.div<{
    $cursor?: 'pointer' | 'not-allowed';
}>`
    position: relative;
    width: 100%;
    overflow: hidden;
    ${({ $cursor }) =>
        $cursor &&
        css`
            &&& * {
                cursor: ${$cursor};
            }
        `}
`;

export const SelectPopoverContent = styled(Popover.Content)`
    width: var(--radix-popover-trigger-width);
    z-index: ${Z_INDEX.MENU};
    background: ${vars.colors.surface.item};
    border-radius: ${vars.radius.md};
    /* shadow.40 token — update to vars.shadow['40'] once Ben's shadow tokens land */
    box-shadow: 0 2px 4px 0 rgba(12, 12, 73, 0.05),
        0 8px 16px 0 rgba(12, 12, 73, 0.05), 0 16px 32px 0 rgba(12, 12, 73, 0.1);
    overflow: hidden;
`;

export const ChevronWrapper = styled.span<{
    $isOpen?: boolean;
    $disabled?: boolean;
}>`
    display: flex;
    align-items: center;
    color: ${({ $disabled }) =>
        $disabled ? vars.colors.text.disabled : vars.colors.text.tertiary};
    transition: transform 0.15s ease;
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'none')};
    flex-shrink: 0;
    cursor: pointer;

    svg * {
        fill: ${({ $disabled }) =>
            $disabled ? vars.colors.text.disabled : vars.colors.text.tertiary};
    }
`;

// Visually hidden but announced by screen readers via aria-live.
export const LiveRegion = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;

// HBBox no longer accepts className directly — withStyles() re-enables
// styled() extension for hbui's own internal use (see ../layout/withStyles.tsx).
export const NoOptionsMessage = styled(withStyles(HBBox))`
    font-family: ${vars.fonts.body};
    font-size: ${fontSizes.s14};
    color: ${vars.colors.text.tertiary};
`;
